import './App.css';
import LandingPage from './pages/LandingPage/LandingPage';
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import RegisterPage from './pages/RegisterPage/RegisterPage';
import LoginPage from './pages/LoginPage/LoginPage';
import HomePage from './pages/HomePage/HomePage';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import ResetPassword from './pages/ResetPassword/ResetPassword';
import CreateListingPage from './pages/CreateListing/CreateListingPage';
import SettingsPage from './pages/SettingsPage/SettingsPage';
import HouseListingPage from './pages/HouseListing/HouseListingPage';
import HouseListingGeneric from './pages/HouseListingGeneric/HouseListingGeneric';
import ViewProfilePage from "./pages/ViewProfilePage/ViewProfilePage";
import DevProfileLauncher from "./pages/DevProfileLaucher";

import NotifcationPage from "./pages/NotificationPage/NotificationPage";
import CommentSection from './components/CommentSection/CommentSection';

import MessagesPage from "./pages/MessagesListPage/MessagesPage";
import DirectMessagePage from "./pages/DirectMessagesPage/DirectMessages";
import EditListingPage from './pages/EditListing/EditListingPage';
import TempConvoLauncher from "./pages/TempConvoLauncher";
import SavedListingsPage from './pages/SavedListingsPage/SavedListingsPage';


/*Package.json should always have path "/CSE442/2025-Fall/cse-442d/" */
const BASE_URL = "/HomeMate/";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage/>}/>
        <Route path="/register" element={<RegisterPage/>}/>
        <Route path="/login" element={<LoginPage/>}/>
        <Route path="/home" element={<HomePage />} />
        <Route path="/forgot" element={<ForgotPassword/>}/>
        <Route path="/reset-password" element={<ResetPassword/>}/>
        <Route path="/create-listing" element={<CreateListingPage/>}/>
        <Route path="/settings" element={<SettingsPage/>}/>
        <Route path="/houseListing" element={<HouseListingPage />} />
        <Route path="/notifications" element={<NotifcationPage />} />
        <Route path="/houseListing/:id" element={<HouseListingGeneric />} />
        <Route path="/saved" element={<SavedListingsPage />} />
        <Route path="/messages" element={<MessagesPage />} />
        <Route path="/messages/new/:userId" element={<DirectMessagePage />} />
        <Route path="/messages/:threadId" element={<DirectMessagePage />} />
        <Route path="*" element={<div style={{padding:16}}>No route matched</div>} />
        <Route path="/404" element={<div style={{padding:16}}>No route matched</div>} />
        <Route path="/profile/:user_id" element={<ViewProfilePage />} />
        <Route path="/dev/profiles" element={<DevProfileLauncher />} />
        <Route path="/edit-listing/:id" element={<EditListingPage />} />


        <Route path="/houseListing/:id" element={<CommentSection />} />
          

          <Route path="/dev/tempDM" element={<TempConvoLauncher />} />
      </Routes>
    </Router>
  );
}

export { BASE_URL };
export default App;
